import { Button } from "@fluentui/react-components";
import { ArrowCircleRight16Regular } from "@fluentui/react-icons";

import { useCategoryTabStore } from "../store/CategoryTabStore";

import { Category } from "../data/Category";
import type { CustomCellRendererProps } from "ag-grid-react";

export default function ViewDetailButton({ value }: CustomCellRendererProps) {
    const { openOptions } = useCategoryTabStore();

    const onClick = () => {
        openOptions(value as Category);
    };

    return (
        <Button
            onClick={onClick}
            appearance="transparent"
            icon={<ArrowCircleRight16Regular />}
            iconPosition="after"
        >
            View
        </Button>
    )
}